import { baseLanguages } from "./languageHandler.util";

export const memoizedSlugs = (): ((path: string) => string | undefined) => {
  const cache: { [key: string]: string | undefined } = {};
  return (path: string): string | undefined => {
    if (path in cache) {
      return cache[path];
    }
    const slugs = path.split("/");
    const slug = slugs[slugs.length - 1]
      ? slugs[slugs.length - 1]
      : slugs[slugs.length - 2];

    if (baseLanguages.includes(slug)) {
      cache[path] = undefined;
      return;
    }
    cache[path] = slug;
    return slug;
  };
};
